// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { List } from 'foundations-components/transitional/components/List';
import { useTheme } from 'foundations-theming/utils';
import ACIcon from '../icon/ACIcon';
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { LessonIcon } from 'foundations-assets/icons/components/LessonIcon';
import { RegistrationIcon } from 'foundations-assets/icons/components/RegistrationIcon';
import { SalesTemplatesIcon } from 'foundations-assets/icons/components/SalesTemplatesIcon';
import { TimeIcon } from 'foundations-assets/icons/components/TimeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACContentBreakdownList = ({
  certificateCount,
  lessonCount,
  videoCount,
  quizCount,
  exerciseCount,
  resourceCount,
  duration
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(List, {
    childStyles: {
      marginInlineEnd: '400',
      marginBlockEnd: '200',
      paddingInline: '0'
    },
    inline: true,
    children: [!!certificateCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: CertificationIcon,
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numCertifications",
        options: {
          count: certificateCount
        }
      })]
    }), !!lessonCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: LessonIcon,
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numLessons",
        options: {
          count: lessonCount
        }
      })]
    }), !!videoCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        insetBlockStart: "4px",
        marginInlineEnd: "200",
        padding: "200",
        position: "relative",
        children: /*#__PURE__*/_jsx(ACIcon, {
          color: theme.color['icon-core-subtle'],
          name: "video",
          size: 18
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numVideos",
        options: {
          count: videoCount
        }
      })]
    }), !!quizCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        display: "inline-block",
        insetBlockStart: "4px",
        marginInlineEnd: "200",
        padding: "200",
        position: "relative",
        children: /*#__PURE__*/_jsx(ACIcon, {
          color: theme.color['icon-core-subtle'],
          name: "quiz",
          size: 18
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numQuizzes",
        options: {
          count: quizCount
        }
      })]
    }), !!exerciseCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: RegistrationIcon,
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numPracticalExercises",
        options: {
          count: exerciseCount
        }
      })]
    }), !!resourceCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: SalesTemplatesIcon,
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.resources",
        options: {
          count: resourceCount
        }
      })]
    }), !!duration && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: TimeIcon,
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedDuration, {
        combined: true,
        format: "medium",
        from: +new Date() - duration * 1000
      })]
    })]
  });
};
export default ACContentBreakdownList;